import { render } from "./CalculadoraFire.vue?vue&type=template&id=23849b42&scoped=true"
import script from "./CalculadoraFire.vue?vue&type=script&lang=js"
export * from "./CalculadoraFire.vue?vue&type=script&lang=js"

import "./CalculadoraFire.vue?vue&type=style&index=0&id=23849b42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23849b42"]])

export default __exports__